//@flow
import React from "react";
import submitTopNine from "../libs/submitTopNine";
import getDeviceInfo from "../libs/getDeviceInfo";
import getProfileByUserName from "../libs/getProfileByUserName";
import { setToken } from "../libs/authorization";
import { path } from "ramda";

const getUsername = path(["data", "login", "sources", 0, "name"]);
const getToken = path(["data", "login", "token"]);

const withAnonymousForm = WrappedComponent =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        username: "",
        email: "",
        maxStep: 4,
        step: 0,
        error: "",
      };
    }
    handleChangeName = x => this.setState({ username: x });
    handleChangeEmail = x => this.setState({ email: x });
    handlePrevStep = () =>
      this.setState(state => ({
        ...state,
        step: state.step - 1 < 0 ? 0 : state.step - 1,
      }));

    handleNextStep = () =>
      this.setState(state => ({
        ...state,
        step: state.step + 1 > state.maxStep ? 0 : state.step + 1,
      }));

    handleSetError = error => this.setState(state => ({ ...state, error }));
    validateForm = () => {
      if (this.state.username === "") return "You need to enter your Instagram username!";
      if (this.state.email === "") return "You need to enter a valid email!";
      var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!re.test(this.state.email.toLowerCase())) return "You need to enter a valid email!";
    };
    handleSubmit = () => {
      this.handleSetError("");
      const invalidError = this.validateForm();
      if (invalidError) {
        this.handleSetError(invalidError);
      } else {
        if (window.gtag) {
          window.gtag("event", "set_email");
        }

        this.handleNextStep();

        if (window.gtag) {
          window.gtag("event", "login", { method: "PublicInstagram" });
        }

        submitTopNine({
          email: this.state.email,
          deviceInfo: getDeviceInfo(),
          country: this.props.country,
          type: "PublicInstagram",
          credentials: {
            publicUserName: this.state.username,
          },
        })
          .then(res => {
            setToken(getToken(res));
            window.location.href = `/best-2020/${getUsername(res)}`;
            this.handleNextStep();
            this.handleChangeName("");
            this.handleChangeEmail("");
          })
          .catch(err => {
            console.log(err);
            if (err.message.includes("private")) {
              this.props.navigateToAuthorizedStep();
            } else if (err.message.includes("country")) {
              this.props.setDisableLoginState({ open: true, err });
              this.handleChangeName("");
              this.handleChangeEmail("");
              this.handleSetError("");
            } else if (err.name === "WebDisabledError") {
              this.props.setDisableLoginState({ open: true, err });
              this.handleChangeName("");
              this.handleChangeEmail("");
              this.handleSetError("");
            }
            this.handleSetError(err.message);
            this.handlePrevStep();
            this.handlePrevStep();
          });
      }
    };

    setEmailInput = emailInput => this.setState({ emailInput });
    handleContinue = () => {
      if (this.state.username) {
        if (this.state.emailInput) {
          setTimeout(() => this.state.emailInput.focus(), 300);
        }
        if (window.gtag) window.gtag("event", "set_username");
        this.handleNextStep();
      } else {
        this.handleSetError("Please enter a valid username!");
      }
    };
    render() {
      return (
        <WrappedComponent
          {...this.props}
          form={this.state}
          handleChangeName={this.handleChangeName}
          handleChangeEmail={this.handleChangeEmail}
          handlePrevStep={this.handlePrevStep}
          handleNextStep={this.handleNextStep}
          handleSubmit={this.handleSubmit}
          handleSetError={this.handleSetError}
          setEmailInput={this.setEmailInput}
          handleContinue={this.handleContinue}
          checkout={this.state.checkout}
          setCheckout={this.setCheckout}
        />
      );
    }
  };

export default withAnonymousForm;
